'use strict';

import childProcess from 'child_process';
import path from 'path';
import log from 'fancy-log';
import pluginError from 'plugin-error';

const PLUGIN_NAME = 'pack-nuget';

interface PackOptions {
    rootPath: string;
    version: string;
    backendVersion: string;
    icon: string;
    readme: string;
    license: string;
    company: string;
    copyright: string;
    targetPath: string;
    // obsolete due to new nuget feature
    iconUrl: string;
}

function runPack(options: PackOptions, callback: Function) {
    const powerShell = 'powershell.exe';
    const script = path.normalize(__dirname + '..\\..\\..\\tools\\scripts\\New-ExtensionPackage.ps1');

    const args = ['-NoProfile', '-File', script];
    if (options.rootPath) {
        args.push('-RootPath', options.rootPath);
    }

    if (options.version) {
        args.push('-Version', options.version);
    }

    if (options.backendVersion) {
        args.push('-BackendVersion', options.backendVersion);
    }

    if (options.icon) {
        args.push('-Icon', options.icon);
    }

    if (options.readme) {
        args.push('-Readme', options.readme);
    }

    if (options.license) {
        args.push('-License', options.license);
    }

    if (options.company) {
        args.push('-Company', options.company);
    }

    if (options.copyright) {
        args.push('-Copyright', options.copyright);
    }

    if (options.targetPath) {
        args.push('-TargetPath', options.targetPath);
    }

    log(powerShell, args.join(' '));
    const cmd = childProcess.spawn(powerShell, args);
    cmd.stdout.on('data', function (data) {
        log(data.toString().trim());
    });
    cmd.stderr.on('data', function (data) {
        log.error(data.toString().trim());
    });
    cmd.on('exit', function (code) {
        if (code !== 0) {
            callback(new pluginError({ plugin: PLUGIN_NAME, message: 'Error: scripts\New-ExtensionPackage.ps1' }));
            return;
        }
        callback();
    });
}

module.exports = runPack;
